/**
 * LogsTab — area activity log. All behavior lives in the shared
 * ProfileLogsTable; this only supplies what differs per entity.
 */

import ProfileLogsTable from '../../../../../components/v2/ProfileLogsTable.jsx';

const LogsTab = ({ logData, tzOffset, showInternal = true }) => (
  <ProfileLogsTable
    logData={logData}
    tzOffset={tzOffset}
    typeKey="area_log_type_name"
    title="Area Logs"
    showInternal={showInternal}
  />
);

export default LogsTab;
